// src/components/common/ErrorState.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

/**
 * ErrorState - Consistent error state component
 * Displays an error message with icon in a styled container
 *
 * @component
 * @example
 * <ErrorState message="Failed to load data: Server error" />
 */
const ErrorState = ({ message = 'An error occurred', title = 'Error' }) => {
  return (
    <Box
      sx={{
        p: 4,
        textAlign: 'center',
        color: 'error.main',
        bgcolor: 'background.paper',
        borderRadius: 1
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: '3rem', mb: 2, opacity: 0.7 }} />
      <Typography variant="h6" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body2">{message}</Typography>
    </Box>
  );
};

ErrorState.propTypes = {
  /** Error message to display */
  message: PropTypes.string,
  /** Error title */
  title: PropTypes.string
};

export default ErrorState;
